// Array of route patterns using regex
const routePatterns = [/^\/reports/, /^\/email-analytics/];

// Function to check if current path matches any route pattern in the array
export const isReportRouteMatch = path => {
  if (!path) return false;
  // Extract pathname from URL if full URL is passed
  const pathname = path.includes("http") ? new URL(path).pathname : path;
  return routePatterns.some(pattern => pattern.test(pathname));
};
